interface SignUpFormSubmitResponse {
    success: boolean;
    successMessage?: string;
    link?: string;
}

export const getTemplate = async (host: string, formId: string) => {
    const response = await fetch(`${host}/public/formTemplate/${formId}`);
    return response.text();
};

export const submitForm = async (host: string, formId: string, formData: any): Promise<SignUpFormSubmitResponse> => {
    const response = await fetch(
        `${host}/public/formTemplate/${formId}`,
        { method: 'POST', body: JSON.stringify(formData), headers: { 'Content-Type': 'application/json' } },
    );

    return response.json();
};
